import { Flex, FlexProps, useBreakpointValue } from "@chakra-ui/react"
import { motion } from "framer-motion"
import React, { FC } from "react"

const MotionFlexBase = motion(Flex)

export interface IMotionFlexProps extends FlexProps {
  background?: string
  responsiveHeight: (number | string | null | undefined)[] | Partial<Record<string, number | string | undefined>>
  transitionTimeInSeconds?: number
}

export const MotionFlex: FC<IMotionFlexProps> = ({
  responsiveHeight,
  transitionTimeInSeconds = 0.25,
  children,
  ...rest
}) => {
  const resolvedHeight = useBreakpointValue(responsiveHeight, { ssr: false })

  return (
    <MotionFlexBase
      animate={{ height: resolvedHeight }} // Use animate for dynamic height changes
      height={resolvedHeight}
      transition={{ duration: transitionTimeInSeconds, ease: "easeInOut" }}
      {...rest} // Spread remaining props
    >
      {children}
    </MotionFlexBase>
  )
}